/**
 * Strip HTML tags and decode common entities for plain-text use (e.g. img alt).
 */
export function stripHtml(value) {
  if (value == null) {
    return ''
  }

  return String(value)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/&amp;/gi, '&')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

/**
 * Parse "-328x328" style dimensions from a media URL when available.
 */
export function dimensionsFromSrc(src) {
  const match = String(src || '').match(/-(\d{2,4})x(\d{2,4})\.(?:webp|jpe?g|png|gif)(?:\?|$)/i)
  if (!match) {
    return null
  }

  return {
    width: Number(match[1]),
    height: Number(match[2]),
  }
}
